/* eslint-disable react/prop-types */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import classNames from 'classnames';
import React, { useCallback, useContext, useMemo } from 'react';
import { Dropdown } from 'react-bootstrap';
import _ from 'lodash/fp';
import { PRODUCT_TYPE } from '../../constants/product';
import text from '../../text';
import { selectionChildren } from '../../utilities/map';
import Icon from '../icon/Icon';
import { getAddOnConfig } from '../mapView/drawingManager/utilities';
import { MapViewContext } from '../mapView/mapViewContext';
import ProductIndicator from './ProductIndicator';
import { isEmpty } from 'lodash';
var ProductMenu = function(param) {
    var data = param.data, className = param.className, _param_closeOnSelect = param.closeOnSelect, closeOnSelect = _param_closeOnSelect === void 0 ? true : _param_closeOnSelect;
    var _useContext = useContext(MapViewContext), actions = _useContext.actions, state = _useContext.state;
    var isAddOnLayerSelected = !!getAddOnConfig(data.category_name);
    var focusedAddOnDataType = useMemo(function() {
        if (!isEmpty(state.selectionProductAvailability)) {
            var _state_selectionProductAvailability;
            var product = (_state_selectionProductAvailability = state.selectionProductAvailability) === null || _state_selectionProductAvailability === void 0 ? void 0 : _state_selectionProductAvailability[data.id][data.category_name];
            var addOnConfig = (product === null || product === void 0 ? void 0 : product.category_name) && getAddOnConfig(product.category_name);
            if (addOnConfig) {
                return addOnConfig.DATA_TYPE;
            }
        }
        return null;
    }, [
        data.category_name,
        data.id,
        state.selectionProductAvailability
    ]);
    var isDisabled = useCallback(function(product) {
        var isAddOn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (!isAddOn) return !product.available;
        return !product.available || !product.category_name.includes(focusedAddOnDataType);
    }, [
        focusedAddOnDataType
    ]);
    var products = useMemo(function() {
        var _state_selectionProductAvailability;
        var isAddOn = function(product) {
            return !!getAddOnConfig(product.category_name);
        };
        return _.map(function(product) {
            return _object_spread_props(_object_spread({}, product), {
                key: product.product_id,
                icon: product.category_name,
                label: text(product.display_name),
                isFocused: product.category_name === data.category_name,
                isDisabled: isDisabled(product, isAddOn(product))
            });
        }, _.pickBy(function(product) {
            var _isAddOn = isAddOn(product);
            if (isAddOnLayerSelected) {
                return _isAddOn;
            }
            return product.category_name !== PRODUCT_TYPE.UNKNOWN && !_isAddOn;
        }, (_state_selectionProductAvailability = state.selectionProductAvailability) === null || _state_selectionProductAvailability === void 0 ? void 0 : _state_selectionProductAvailability[data.id]));
    }, [
        data.category_name,
        data.id,
        isAddOnLayerSelected,
        isDisabled,
        state.selectionProductAvailability
    ]);
    var handleProductTypeClick = function(productType) {
        return function(event) {
            var _state_activeSelection;
            event.preventDefault();
            var availableProductData = _.find([
                'category_name',
                productType
            ], products);
            var updatedSelection = function() {
                return actions.changeSelectionProductType(data.id, availableProductData);
            };
            var activeSelectionChildren = selectionChildren(state.selections, ((_state_activeSelection = state.activeSelection) === null || _state_activeSelection === void 0 ? void 0 : _state_activeSelection.id) || data.id);
            if (activeSelectionChildren.length > 0) {
                actions.showChangeProductTypeConfirmation(productType, activeSelectionChildren, function() {
                    // callback
                    var newSelection = updatedSelection();
                    actions.setActiveSelectionId(newSelection.id);
                    actions.setHoveredData(null);
                    actions.setProductSelectedOnMakeSelection(newSelection);
                });
                return;
            }
            var newSelection = updatedSelection();
            if (state.activeSelection && state.activeSelection.id === newSelection.id) {
                actions.setActiveSelectionId(data.id);
                actions.setHoveredData(null);
                actions.setProductSelectedOnMakeSelection(newSelection);
            }
            // After changing type, assign newSelection to setOpenedShapeMenuData that is opened
            if (state.openedShapeMenu.data && !closeOnSelect) {
                actions.setOpenedShapeMenu(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        data: _object_spread_props(_object_spread({}, newSelection), {
                            index: data.index
                        }),
                        prevCategoryName: data.category_name
                    });
                });
            }
        };
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames('product-menu', className)
    }, products === null || products === void 0 ? void 0 : products.map(function(product) {
        var key = product.key, label = product.label, category_name = product.category_name, isFocused = product.isFocused, isDisabled = product.isDisabled;
        return /*#__PURE__*/ React.createElement(Dropdown.Item, {
            key: key,
            disabled: isDisabled,
            onClick: handleProductTypeClick(category_name)
        }, /*#__PURE__*/ React.createElement(ProductIndicator, {
            className: classNames(category_name, isFocused && 'focus'),
            categoryName: category_name,
            isFocused: isFocused,
            isDisabled: isDisabled
        }), /*#__PURE__*/ React.createElement("span", {
            className: "product-label"
        }, label), /*#__PURE__*/ React.createElement("div", {
            className: classNames('product-tick', isFocused && 'focus')
        }, /*#__PURE__*/ React.createElement(Icon, {
            icon: "tick"
        })));
    }));
};
export default ProductMenu;
